<template>
	<div class = "order-code-div">
		<div v-if="status <= 2">
			<img src="../../assets/time.png"/>
			<div class = "order-code-context">排队下单中,预计5-10分钟，请耐心等待！</div>
			<div class = "order-code-tip">将短信通知取单号，或稍后查看我的订单</div>
		</div>
		<div v-else-if="status >= 3 && status<5">
			<img src="../../assets/key.png"/>
			<!-- <div class = "order-code-context">取单口令：{{takeFoodCode}}</div> -->
			<div class="order-code-context">订单已完成，请使用取餐口令取餐</div>
		</div>
		<div v-else-if="status == 5">
			<img src="../../assets/key.png"/>
			<div class = "order-code-context">下单失败，请联系客服</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'OrderCode',
		props:{
			status:{
				Number,
				default:1,
			},
		    takeFoodCode:{
				 String,
				 default:'', 
			}
	  },
		data(){
			return {
			}
		},
		methods:{
			
		}
	}
</script>

<style scoped>
	.order-code-div {
		background-color: #ffffff;
		text-align: center;
		padding: 20px;
	}
	.order-code-div img{
		width: 38px;
		height: 38px;
		display: block;
		margin: 20px auto;
	}
	.order-code-context {
		font-size: 16px;
		line-height: 20px;
		font-weight: 550;
		color: #333333;
	}
	
	.order-code-tip {
		font-size: 14px;
		color: #666666;
	}
</style>
